import React, { useState, createRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

export const ImageInputComponent = ({
    value,
    changeValue,
    name,
    subName,
    id,
    required = false,
}) => {
    const [image, setImage] = useState(null);
    const [open, setOpen] = useState(false);
    const cropperRef = createRef();

    const getFileName = () => {
        if (!value) return 'No image chosen';
        if (value.bytes && value.bytes.name) return value.bytes.name;
        if (typeof value === 'string') return value.split('/').pop();
        if (value instanceof File) return value.name;
        return 'Image selected';
    };

    const handleFileChange = (e) => {
        e.preventDefault();
        let files = e.target.files;
        if (files && files.length > 0) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result);
                setOpen(true);
            };
            reader.readAsDataURL(files[0]);
        }
        e.target.value = null;
    };

    const handleClose = () => {
        setOpen(false);
        setImage(null);
    };

    const getCropData = () => {
        const cropper = cropperRef.current?.cropper;
        if (typeof cropper !== "undefined") {
            cropper.getCroppedCanvas({
                width: 1024,
                height: 1024,
            }).toBlob((blob) => {
                if (!blob) return;
                const file = new File([blob], "cropped.jpg", { type: "image/jpeg" });
                changeValue({ target: { files: [file] } });
                handleClose();
            }, "image/jpeg", 0.9);
        }
    };

    const aspectRatio = id === "photo" ? 1 : 16 / 9;

    return (
        <div className="bg-white px-10 sm:px-20 py-5 sm:py-10 rounded-xl border-l-4 border-[#5d5df1] mb-3">
            <label htmlFor={id} className="font-medium">{name}</label>
            {subName && <label htmlFor={id} className="text-gray-400"> ({subName})</label>}
            {required && <label className="text-[red] pl-1">*</label>}
            <br />
            <div className="mt-4 relative">
                <input
                    type="file"
                    id={id}
                    required={required && !value}
                    accept="image/png, image/jpeg"
                    onChange={handleFileChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                />

                <div className="flex items-center w-4/5 sm:w-3/5 border border-gray-300 rounded-lg bg-gray-50 p-2 cursor-pointer">
                    <span className="text-sm text-gray-700 flex-1 truncate">
                        {getFileName()}
                    </span>
                    <span className="text-sm font-medium text-[#5d5df1] ml-4">
                        Choose File
                    </span>
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
            >
                <div className="bg-white p-4 font-semibold text-lg border-b">
                    Crop {name}
                </div>
                <DialogContent>
                    <div className="w-full flex flex-col md:flex-row gap-4 mt-2">
                        <div className="w-full md:w-2/3">
                            <Cropper
                                ref={cropperRef}
                                style={{ height: 400, width: "100%" }}
                                aspectRatio={aspectRatio}
                                preview=".img-preview"
                                src={image}
                                viewMode={1}
                                minCropBoxHeight={100}
                                minCropBoxWidth={100}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                                guides={true}
                            />
                        </div>
                        <div className="w-full md:w-1/3 flex flex-col items-center">
                            <p className="font-medium mb-2 text-center w-full">Preview</p>
                            <div className="img-preview overflow-hidden rounded-md border" style={{ width: '100%', aspectRatio: aspectRatio }} />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="p-4 border-t">
                    <button 
                        className="bg-gray-200 px-6 py-2 text-sm text-gray-800 rounded-md font-medium hover:bg-gray-300 transition-colors" 
                        onClick={handleClose}
                    >
                        Cancel
                    </button>
                    <button 
                        className="bg-[#5c33ae] px-6 py-2 text-sm text-white rounded-md font-medium hover:bg-[#2f0e70] transition-colors" 
                        onClick={getCropData}
                    >
                        Crop & Save
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
